import { forwardRef } from "react";

import { Avatar, useTheme } from "@mui/material";

const OmniAvatar = (props, ref) => {
  const theme = useTheme();

  return (
    <Avatar
      ref={ref}
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        flexGrow: 1,
        fontFamily: theme.typography.fontFamily,
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        cursor: "pointer",
        pointerEvents: "all",
      }}
      {...props}
    />
  );
};

export default forwardRef(OmniAvatar);
